// extracted by mini-css-extract-plugin
module.exports = {"img2":"HomeIntro_img2__1SLb8","span":"HomeIntro_span__1LOuq","grid":"HomeIntro_grid__14TjE"};